// extracted by mini-css-extract-plugin
export default {"page":"src-components-common-Layout-layout-module__pagel9h2_","container":"src-components-common-Layout-layout-module__containerAnrp_"};